import { areAnalyticsEnabledInEnv, useAnalytics } from '@cosuno/analytics-frontend';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const NavigationObserver = () => {
  const { trackPageView } = useAnalytics();
  const history = useHistory();

  useEffect(() => {
    if (!areAnalyticsEnabledInEnv()) return;

    return history.listen(() => {
      trackPageView();
    });
  }, [history, trackPageView]);

  return null;
};

export default NavigationObserver;
